import moment from 'moment';
import { useMemo } from 'react';
import { useSelector } from 'src/client/redux/modules/helpers/useSelector';
import { useRouteMatch } from 'react-router';
import { MetArt, SexArt } from 'src/client/constants/sites';

type BlogDateParams = {
  pageOrDate: string;
};

type BlogPostParams = {
  date: string;
  name: string;
};

type BlogCategoryParams = {
  category: string;
  page: string;
};

// SEO_CLEANUP
export const useGetBlogTitle = () => {
  const siteAbbreviation = useSelector((state) => state.site.abbreviation);
  const matchBlogDateWithPost = useRouteMatch<BlogPostParams>('/blog/:date/:name');
  const matchBlogArchive = useRouteMatch<BlogDateParams>('/blog/:pageOrDate');
  const matchBlogCategory = useRouteMatch<BlogCategoryParams>('/blog/:category/:page');

  const getBlogTitle = useMemo(() => {
    if (siteAbbreviation !== MetArt.abbreviation && siteAbbreviation !== SexArt.abbreviation) return undefined;

    if (
      matchBlogDateWithPost?.isExact &&
      matchBlogDateWithPost.params.date !== 'category' &&
      matchBlogDateWithPost.params.name
    ) {
      return undefined;
    }

    if (matchBlogCategory?.isExact && matchBlogCategory.params) {
      const { page } = matchBlogCategory.params;
      if (page) {
        const formattedCategory = page
          .split('_')
          .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
          .join(' ');
        return `${formattedCategory} Blog`;
      }
    }

    if (matchBlogArchive?.isExact && matchBlogArchive.params) {
      const { pageOrDate } = matchBlogArchive.params;
      if (pageOrDate) {
        const formattedDate = moment(pageOrDate, 'YYYYMMDD').format('MMMM YYYY');
        return `Erotic Art Archives ${formattedDate}`;
      }
    }
    let blogTitle;

    if (siteAbbreviation === MetArt.abbreviation) {
      blogTitle = 'Blog of Erotica Art';
    }

    if (siteAbbreviation === SexArt.abbreviation) {
      blogTitle = 'Porn Stories - News and Updates';
    }

    return blogTitle;
  }, [matchBlogDateWithPost, matchBlogArchive, matchBlogCategory, siteAbbreviation]);

  return getBlogTitle;
};
